import { CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';

const {
  REACT_APP_AWS_COGNITO_USER_POOL_ID,
  REACT_APP_AWS_COGNITO_CLIENT_ID,
} = process.env;

export const getAWSCognitoUserPool = () =>
  new CognitoUserPool({
    UserPoolId: REACT_APP_AWS_COGNITO_USER_POOL_ID || '',
    ClientId: REACT_APP_AWS_COGNITO_CLIENT_ID || '',
  });

export const getAWSCognitoUser = (username: string | undefined) => {
  if (username) {
    return new CognitoUser({
      Username: username,
      Pool: getAWSCognitoUserPool(),
    });
  } return null;
};

// Current rules on AWS Cognito for password:
// - Must be at least 8 characters
// - Must contain at least one lowercase letter
// - Must contain at least one number
// We replicate this in the frontend to provide immediate feedback to the user
// before the password reset code is sent
export const isPasswordSecure = (password: string) => {
  const regex = /^(?=.*\d)(?=.*[a-z]).{8,}$/;
  return regex.test(password);
};
